import React, { useState, useMemo } from "react";

import { ActionsMenu, MenuItem, BasicActionsMenuProps } from "ui/actions-menu";

import Icons from "assets";

interface PersonasActionsMenuProps extends BasicActionsMenuProps {
  onEdit: (id: string) => void;
  onDelete: (id: string) => void;
}

const SmsSimulatorPersonasTableActionsMenu: React.FC<PersonasActionsMenuProps> = ({
  item,
  onEdit,
  onDelete,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleMenuOpen = () => setIsOpen(true);
  const handleMenuClose = () => setIsOpen(false);

  const actionItems = useMemo(
    () => [
      {
        icon: <Icons.Edit />,
        label: "Edit persona details",
        onClick: (id: string) => onEdit(id),
      },
      {
        icon: <Icons.Trash />,
        label: "Delete persona",
        onClick: (id: string) => onDelete(id),
      },
    ],
    [onEdit, onDelete],
  );

  return (
    <ActionsMenu itemName={item.itemName} open={isOpen} onOpen={handleMenuOpen} onClose={handleMenuClose}>
      {actionItems.map((actionItem) => (
        <MenuItem
          key={actionItem.label}
          icon={actionItem.icon}
          label={actionItem.label}
          onClick={() => {
            if (item.itemId) {
              actionItem.onClick(item.itemId);
            }
            setIsOpen(false);
          }}
        />
      ))}
    </ActionsMenu>
  );
};

export default SmsSimulatorPersonasTableActionsMenu;
